module.exports = __webpack_public_path__ + "static/media/services-open.9d926bc8.svg";